import '@babel/polyfill';
import Vue from 'vue';
import store from './store';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
// eslint-disable-next-line
import { library } from '@fortawesome/fontawesome-svg-core';
// eslint-disable-next-line
import { faCoffee, faUser, faFileAlt, faUnlink, faDatabase, faAngleLeft, faAngleRight, faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
// eslint-disable-next-line
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Interceptors from './services/interceptors';

library.add(faCoffee, faUser, faFileAlt, faUnlink, faDatabase, faAngleLeft, faAngleRight, faAngleDoubleLeft, faAngleDoubleRight);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

const VueTruncate = require('vue-truncate-filter');

Vue.use(VueTruncate);
// export const agentBus = new Vue();

Interceptors.Setup();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
